<div class="note-box" style="flex-grow: 0;display:flex;" *ngIf='canShow' 
    [class.default]='type === "Default"' 
    [class.info]='type === "Info"'
>
    <div style="width: calc(100% - 40px); display: flex; flex-direction: row;align-content: center;align-items: center;">
        <i class="{{icon}} note-box-icon"></i>
        <div>
            <ng-content></ng-content>
        </div>
    </div>

    <div *ngIf="closable" (click)="canShow = false;"
    style="width: 40px;display: flex;
        text-align: center;
        justify-content: center;flex-direction: column;cursor: pointer;">
        <span  class="fas fa-times"></span>
    </div>

    
</div>
<!--width: calc(100% - 40px);display: flex;flex-direction: row;align-content: center;align-items: center;-->